<script>
  /**
   * @type {"Revokation Status"|"Document Status"} active tab while generating files
   */
  export let activeItem
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  export let activeDoc

  /**
   * @type {String} activeColor of the tabs
   */
  let activeColor

  /**
   * @type {Array<import("../../../Script/document".Tab)>}
   */
  let TabList = [
    { name: "Revokation Status", icon1: "fa-circle-check", icon2: "fa-clock" },
    { name: "Document Status", icon1: "fa-file-check", icon2: "fa-file" },
  ]

  $: changeActiveColor(activeDoc)

  /**
   * Function for changing the active color of the tabs
   * @param {String} activeDoc the current state of the document status
   */
  const changeActiveColor = (activeDoc) => (activeColor = activeDoc == "completed" ? "#22C55E" : "#FF6A00")
</script>

<div class="flex min-h-[37.6px] w-full border-b border-gray-100 bg-white dark:rounded-t-md dark:border-none dark:bg-zinc-900 dark:shadow-lg">
  <div class="flex h-full w-full gap-6 px-3 font-bold text-gray-d00 mobile:px-12">
    {#each TabList as Tab}
      <button
        disabled={activeDoc == "start" && Tab.name === "Document Status"}
        on:click={() => {
          activeItem = Tab.name
        }}
        style="color : {activeItem == Tab.name ? activeColor : '#616161'};border-color : {activeItem == Tab.name ? activeColor : 'transparent'} "
        class="tab-class disabled:cursor-not-allowed"
      >
        <i class="fa-solid {activeDoc == 'completed' ? Tab.icon1 : Tab.icon2}" />
        <p class="text-left mobile:text-center sm:w-full">{Tab.name}</p>
      </button>
    {/each}
  </div>
</div>

<style lang="postcss">
  .tab-class {
    @apply flex w-auto items-center gap-2 border-b-[3px] py-2 text-xs outline-none md:text-sm lg:text-base;
  }
</style>
